import {graphql, useStaticQuery} from 'gatsby'

import {locationsFields} from '../helpers/fragments'

export const useLayoutData = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulHeader(filter: {name: {eq: "Header"}}) {
        edges {
          node {
            node_locale
            ourSitesLabel
            headerMenu {
              menuItems {
                isExternalLink
                isOpenInNewWindow
                isSameMenuItemForAllCountries
                link
                name
                title
                menuItemPerCountry {
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  link
                  name
                  title
                  countries {
                    countryCode
                    urlPrefix
                    technicalName
                  }
                }
                childMenu {
                  isSameMenuForAllCountries
                  menuItems {
                    isExternalLink
                    isOpenInNewWindow
                    isSameMenuItemForAllCountries
                    link
                    name
                    title
                  }
                }
              }
            }
            contactUs {
              link
              title
            }
            findAJob {
              title
              menuItemPerCountry {
                countries {
                  technicalName
                }
                link
              }
            }
            logo {
              title
              file {
                url
              }
            }
          }
        }
      }
      allContentfulContinent {
        edges {
          node {
            node_locale
            id
            name
            slug
            countries {
              technicalName
              urlPrefix
              countryCode
              id
              name
              language {
                id
                localCode
                name
              }
            }
          }
        }
      }
      allContentfulFooter(filter: {name: {eq: "Footer"}}) {
        edges {
          node {
            node_locale
            logo {
              title
              file {
                url
                contentType
              }
            }
            socialMediaLinks {
              name
              link
              id
              icon {
                file {
                  url
                }
              }
              iconHover {
                file {
                  url
                }
              }
            }
            locations {
              faxLabel
              phoneLabel
            }
            firstFooterMenu {
              name
              title
              menuItems {
                name
                menuItemPerCountry {
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  link
                  name
                  title
                  countries {
                    urlPrefix
                    technicalName
                  }
                }
                menu_item {
                  link
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  name
                  title
                }
                isOpenInNewWindow
                isSameMenuItemForAllCountries
                isExternalLink
                link
                id
                title
              }
            }
            secondFooterMenu {
              name
              title
              menuItems {
                name
                menu_item {
                  link
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  name
                  title
                }
                isOpenInNewWindow
                isSameMenuItemForAllCountries
                isExternalLink
                link
                id
                title
              }
            }
            thirdFooterMenu {
              name
              title
              menuItems {
                name
                menu_item {
                  link
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  name
                  title
                }
                isOpenInNewWindow
                isSameMenuItemForAllCountries
                isExternalLink
                link
                id
                title
              }
            }
            bottomMenu {
              menuItems {
                id
                link
                isOpenInNewWindow
                isSameMenuItemForAllCountries
                isExternalLink
                title
                menuItemPerCountry {
                  isExternalLink
                  isOpenInNewWindow
                  isSameMenuItemForAllCountries
                  link
                  name
                  title
                  countries {
                    urlPrefix
                    technicalName
                    countryCode
                  }
                }
              }
            }
          }
        }
      }
      allContentfulLocations(filter: {slug: {regex: "/^((?!-kls).)*$/"}}) {
        edges {
          node {
            ...locationsFields
          }
        }
      }
      allContentfulPlaybook {
        edges {
          node {
            searchPlaceholder
            node_locale
          }
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
      allContentfulRedirectionPopUp {
        edges {
          node {
            cta1
            cta2
            textContent {
              textContent
            }
            countries {
              technicalName
            }
            node_locale
          }
        }
      }
      allSitePage {
        distinct(field: {path: SELECT})
      }
    }
  `)

  return data
}
